import React from 'react';
import { styled } from '@material-ui/core';
import { ReactComponent as SearchIcon } from 'assets/icons/ic-search.svg';

export const RootComponent = styled('div')({
  width: '100%',
  height: '40px',
  display: 'flex',
  alignItems: 'stretch',
  justifyContent: 'flex-start',
});

export const BaseInput = styled('input')(({ theme, adornment }) => {
  return {
    cursor: 'text',
    width: '100%',
    fontFamily: 'inherit',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0px',
    textAlign: 'left',
    padding: '10px 15px',
    border: '1px solid',
    borderRadius: adornment ? '4px 0px 0px 4px' : '4px',
    borderColor: theme.palette.xpl.stoke,
    minWidth: 0,
    flex: '1 1 auto',
    '&::placeholder': {
      color: theme.palette.xpl.text.secondary,
    },
    '&:disabled': {
      backgroundColor: theme.palette.xpl.action.disabled,
      color: theme.palette.xpl.text.secondary,
      '&:hover': {},
      pointerEvents: 'none',
    },
    '&:hover': {
      borderColor: theme.palette.xpl.secondary.hover,
    },
    '&:focus': {
      borderColor: theme.palette.xpl.secondary.hover,
    },
  };
});

export const AdornmentContainer = styled('div')({
  flex: '0 0 auto',
});

export const AdornmentPrimaryButton = styled('button')(
  ({ theme, divider }) => ({
    backgroundColor: theme.palette.xpl.secondary.default,
    color: theme.palette.xpl.foreground,
    padding: '12px 17px',
    borderWidth: divider ? '0 0 0 1px' : '0',
    borderRadius: '0px 4px 4px 0px',
    cursor: 'pointer',
    width: '100%',
    height: '100%',
    outline: 'none',
  })
);

export const AdornmentSecondaryButton = styled('button')(({ theme }) => ({
  backgroundColor: theme.palette.xpl.foreground,
  color: theme.palette.xpl.text.primary,
  padding: '12px 17px',
  borderWidth: '1px 1px 1px 0',
  borderStyle: 'solid',
  borderRadius: '0px 4px 4px 0px',
  borderColor: theme.palette.xpl.stoke,
  cursor: 'pointer',
  width: '100%',
  height: '100%',
  outline: 'none',
}));

export const SearchIconButton = (props) => {
  const { variant } = props;

  if (variant === 'primary') {
    return (
      <AdornmentPrimaryButton {...props}>
        <SearchIcon />
      </AdornmentPrimaryButton>
    );
  } else if (variant == 'secondary') {
    return (
      <AdornmentSecondaryButton {...props}>
        <SearchIcon />
      </AdornmentSecondaryButton>
    );
  } else {
    return (
      <AdornmentPrimaryButton {...props}>
        <SearchIcon />
      </AdornmentPrimaryButton>
    );
  }
};
